export default __webpack_public_path__ + "static/media/technologyWebSite2.691cb1a1.jpg";